export interface InvestmentInterestGrid {
    id: number;
    entityName: string;
    entityTypeDescription: string;
    shareClass: string;
    shareCount: number | null;
    amount: number;
    accreditationDescription: string;
    fundingMethodDescription: string;
    email: string;
    cellPhone: string;
    approved: boolean;
    fundingStatus: number;
    fundingStatusDescription: string;
}

export class InvestmentInterestGrid implements InvestmentInterestGrid {
    constructor(init?: InvestmentInterestGrid) {
        Object.assign(this, init);
    }
}

export enum FundingStatus {
    unknown = 0,
    awaitingTransfer = 1,
    sentAwaitingConfirmation = 2,
    pending = 3,
    funded = 4,
    error = 5,
    canceled = 6,
}

export enum InvestmentFundingMethod {
    unknown = 0,
    crypto = 1,
    ach = 2,
    wireTransfer = 3,
    check = 4,
}